import { Dispatch } from 'redux';

import { RootState } from '../reducers/store';
import { ToolboxReducerActionType } from '../reducers/toolboxReducer';
import { ToolboxFolderResponseType } from '../features/Toolbox/types';
import { MediaApiResponseType } from 'src/types';

export const FOLDER_LIST_TOOLBOX = 'folder_list_toolBoxes';
export const ADD_FOLDER_TOOLBOX = 'add_folder_toolbox';
export const ADD_FILES_TO_FOLDER_TOOLBOX = 'add_files_to_folder_toolbox';
export const UPDATE_FOLDER_NAME_TOOLBOX = 'update_folder_name_toolbox';
export const UPDATE_FILE_NAME_TOOLBOX = 'update_file_name_toolbox';
export const DELETE_FOLDER_TOOLBOX = 'delete_folder_toolbox';
export const DELETE_FILE_TOOLBOX = 'delete_file_toolbox';
export const ADD_FOLDER_HISTORY_TOOLBOX = 'add_folder_history_toolbox';
export const DELETE_LAST_FOLDER_HISTORY_TOOLBOX =
  'delete_last_folder_history_toolbox';
export const RESET_FOLDER_HISTORY_TOOLBOX = 'reset_folder_history_toolbox';

export const getFolderList =
  (id: string, successCalback: () => void) =>
  (dispatch: Dispatch<ToolboxReducerActionType>, getState: () => RootState) => {
    const {
      client: { get },
    } = getState();

    get(
      `/customers/directory/toolbox/${id}`,
      (response: { data: ToolboxFolderResponseType }): void => {
        response &&
          dispatch({
            type: FOLDER_LIST_TOOLBOX,
            payload: response.data,
          });
        successCalback();
      }
    );
  };

export const createFolder =
  (
    data: { name: string; parent: { id: string } },
    successCalback: () => void,
    failureCallback: () => void
  ) =>
  async (
    dispatch: Dispatch<ToolboxReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { postPromise, getPromise },
    } = getState();

    try {
      const directoryId = await postPromise(
        '/customers/directory/toolbox',
        data
      );

      const response = await getPromise(
        `/customers/directory/toolbox/${directoryId}`
      );

      successCalback();

      response.data &&
        dispatch({
          type: ADD_FOLDER_TOOLBOX,
          payload: response.data,
        });
    } catch (error: any) {
      error.status && failureCallback();
    }
  };

export const addFilesToFolder =
  (media: MediaApiResponseType) =>
  (dispatch: Dispatch<ToolboxReducerActionType>) => {
    dispatch({
      type: ADD_FILES_TO_FOLDER_TOOLBOX,
      payload: media,
    });
  };

export const updateFolderName =
  (
    folder: { id: string; name: string },
    successCalback: () => void,
    failureCallback: () => void
  ) =>
  async (
    dispatch: Dispatch<ToolboxReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { patch },
    } = getState();

    patch(
      `/customers/directory/toolbox/${folder.id}`,
      { name: folder.name },
      () => {
        successCalback();
        dispatch({
          type: UPDATE_FOLDER_NAME_TOOLBOX,
          payload: folder,
        });
      },
      () => failureCallback()
    );
  };

export const updateFileName =
  (
    file: { id: string; name: string },
    successCalback: () => void,
    failureCallback: () => void
  ) =>
  async (
    dispatch: Dispatch<ToolboxReducerActionType>,
    getState: () => RootState
  ) => {
    const {
      client: { patch },
    } = getState();

    patch(
      `/medias/${file.id}`,
      { name: file.name },
      () => {
        successCalback();
        dispatch({
          type: UPDATE_FILE_NAME_TOOLBOX,
          payload: file,
        });
      },
      () => failureCallback()
    );
  };

export const deleteFolder =
  (id: string, successCalback: () => void, failureCallback: () => void) =>
  (dispatch: Dispatch<ToolboxReducerActionType>, getState: () => RootState) => {
    const {
      client: { deletion },
    } = getState();

    deletion(
      `/customers/directory/toolbox/${id}`,
      {},
      () => {
        successCalback();
        dispatch({
          type: DELETE_FOLDER_TOOLBOX,
          payload: id,
        });
      },
      () => failureCallback()
    );
  };

export const deleteFile =
  (id: string, successCalback: () => void, failureCallback: () => void) =>
  (dispatch: Dispatch<ToolboxReducerActionType>, getState: () => RootState) => {
    const {
      client: { deletion },
    } = getState();

    deletion(
      `/medias/${id}`,
      {},
      () => {
        successCalback();
        dispatch({
          type: DELETE_FILE_TOOLBOX,
          payload: id,
        });
      },
      () => failureCallback()
    );
  };

export const addFolderHistory =
  (folder: ToolboxFolderResponseType) =>
  (dispatch: Dispatch<ToolboxReducerActionType>) => {
    dispatch({
      type: ADD_FOLDER_HISTORY_TOOLBOX,
      payload: folder,
    });
  };

export const deleteLastFolderHistory =
  () => (dispatch: Dispatch<ToolboxReducerActionType>) => {
    dispatch({
      type: DELETE_LAST_FOLDER_HISTORY_TOOLBOX,
    });
  };

export const resetFolderHistory =
  () => (dispatch: Dispatch<ToolboxReducerActionType>) => {
    dispatch({
      type: RESET_FOLDER_HISTORY_TOOLBOX,
    });
  };
